// extracted by mini-css-extract-plugin
export default {"Title":"VideoInfo_Title__eCuMY"};